// ==========================
// ELEMENT SELECTORS
// ==========================
const allWrappers = document.querySelectorAll(".main-facilitator .facilitator-wrapper");
const allInputs = document.querySelectorAll("#facilitator_search");
const allGrids = document.querySelectorAll(".main-facilitator .facilitator-grid");
const allDropdowns = document.querySelectorAll(".dropdown");
const allDropdownMenus = document.querySelectorAll("#dropdownMenu");
const allApplyFilters = document.querySelectorAll("#applyFilter");
const allInputFields = document.querySelectorAll('.facilitator-field .field__input');
const allCloseButtons = document.querySelectorAll('.facilitator-field .button-clear');
const allEmptyStates = document.querySelectorAll(".main-facilitator .empty-state");
const allFacilitatorRelated = document.querySelectorAll('.facilitator-related');
const allResetFilters = document.querySelectorAll("#resetFilter");

// ==========================
// SEARCH RESULTS DIV (ONLY FIRST SECTION)
// ==========================
let searchResultsDiv = document.createElement("div");
searchResultsDiv.classList.add("facilitator-search-results");
if (allGrids.length > 0) {
  allGrids[0].parentNode.insertBefore(searchResultsDiv, allGrids[0].nextSibling);
}

// ==========================
// STATE
// ==========================
let selectedCountries = [];

// ==========================
// HELPER FUNCTION
// ==========================
function updateWrapperClass(inputField, wrapper) {
  wrapper.classList.toggle("has-value", inputField.value.trim() !== "");
}

// ==========================
// FILTER FUNCTION (ALL SECTIONS)
// ==========================
function filterCards() {
  const searchTerm = Array.from(allInputs).map(i => i.value.trim().toLowerCase()).join(" ");
  searchTermTrimmed = searchTerm.trim();
  
  // collect all visible cards from all sections
  let visibleCards = [];

  allGrids.forEach(grid => {
    const cards = grid.querySelectorAll(".facilitator-grid__item");
    cards.forEach(card => {
      const name = card.querySelector(".facilitator_card__heading")?.textContent.toLowerCase() || "";
      const location = card.querySelector(".facilitator_location")?.textContent.toLowerCase() || "";
      const categoryEl = card.querySelector(".facilitator_list__category");
      const tags = categoryEl ? categoryEl.textContent.toLowerCase() : "";
      const country = card.getAttribute("data-country")?.toLowerCase() || "";

      const matchesSearch =
        name.includes(searchTermTrimmed) ||
        location.includes(searchTermTrimmed) ||
        tags.includes(searchTermTrimmed);

      const matchesCountry =
        selectedCountries.length === 0 || selectedCountries.includes(country);

      if (matchesSearch && matchesCountry) {
        visibleCards.push(card.cloneNode(true)); // clone instead of outerHTML
      }
    });
  });

  // ==========================
  // UPDATE DISPLAY
  // ==========================
  if (visibleCards.length > 0 && (searchTermTrimmed || selectedCountries.length > 0)) {
    allGrids.forEach(g => g.style.display = "none"); // hide all grids
    searchResultsDiv.innerHTML = ""; // clear first
    visibleCards.forEach(card => searchResultsDiv.appendChild(card)); // append clones
    searchResultsDiv.style.display = "flex";

    allEmptyStates.forEach(es => es.style.display = "none");
    allFacilitatorRelated.forEach(fr => fr.style.display = "none");
  } else if ((searchTermTrimmed || selectedCountries.length > 0) && visibleCards.length === 0) {
    allGrids.forEach(g => g.style.display = "none");
    searchResultsDiv.style.display = "none";

    allWrappers.forEach((wrapper, index) => {
    if (index === 0) {
      wrapper.style.display = "block"; // keep first visible
    } else {
      wrapper.style.display = "none"; // hide others
    }
  });
    
    allEmptyStates.forEach(es => es.style.display = "block");
    allFacilitatorRelated.forEach(fr => fr.style.display = "block");
  } else {
    allGrids.forEach(g => g.style.display = "flex");
    searchResultsDiv.style.display = "none";
    allEmptyStates.forEach(es => es.style.display = "none");
    allFacilitatorRelated.forEach(fr => fr.style.display = "none");
  }
}

// ==========================
// EVENTS
// ==========================

// SEARCH INPUT
allInputs.forEach((input, index) => {
  input.addEventListener("keyup", () => {
    filterCards();
    updateWrapperClass(allInputFields[index], allWrappers[index]);
  });
});

// APPLY FILTER BUTTON
allApplyFilters.forEach((btn, index) => {
  btn.addEventListener("click", () => {
    const menu = allDropdownMenus[index];
    const allCheckbox = menu.querySelector('#all-countries'); // "All Countries" checkbox

    // If "All Countries" is checked
    if (allCheckbox && allCheckbox.checked) {
      // Uncheck other checkboxes
      menu.querySelectorAll("input[type=checkbox]").forEach(cb => {
        if (cb !== allCheckbox) cb.checked = false;
      });

      // Empty selectedCountries = show all cards
      selectedCountries = [];
    } else {
      // Collect selected countries (ignore "all")
      selectedCountries = Array.from(
        menu.querySelectorAll("input[type=checkbox]:checked")
      )
      .filter(cb => cb.value.toLowerCase() !== "all")
      .map(cb => cb.value.toLowerCase());
    }

    // Show/hide reset button
    if (selectedCountries.length > 0 || (allCheckbox && allCheckbox.checked)) {
      allResetFilters[index].style.display = "inline-block";
    } else {
      allResetFilters[index].style.display = "none";
    }

    // Run filtering
    filterCards();

    // Close dropdown after applying
    allDropdowns[index].removeAttribute("open");
  });
});

// APPLY FILTER ON CHECKBOX CLICK INSTEAD OF BUTTON
allDropdownMenus.forEach((menu, index) => {
  const allCheckbox = menu.querySelector('#all-countries'); // "All Countries" checkbox
  
  menu.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      // If "All Countries" is clicked
      if (checkbox.id === "all-countries" && checkbox.checked) {
        // Uncheck all others
        menu.querySelectorAll("input[type=checkbox]").forEach(cb => {
          if (cb !== allCheckbox) cb.checked = false;
        });
        selectedCountries = []; // empty = show all
      } else {
        // Uncheck "All" if specific ones selected
        if (allCheckbox) allCheckbox.checked = false;

        // Collect selected countries (ignore "all")
        selectedCountries = Array.from(
          menu.querySelectorAll("input[type=checkbox]:checked")
        )
        .filter(cb => cb.value.toLowerCase() !== "all")
        .map(cb => cb.value.toLowerCase());
      }

      // Show/hide reset button
      if (selectedCountries.length > 0 || (allCheckbox && allCheckbox.checked)) {
        allResetFilters[index].style.display = "inline-block";
      } else {
        allResetFilters[index].style.display = "none";
      }

      filterCards();
    });
  });
});


// RESET FILTER BUTTON
allResetFilters.forEach((btn, index) => {
  btn.addEventListener("click", () => {
    // Uncheck all checkboxes
    allDropdownMenus[index].querySelectorAll("input[type=checkbox]").forEach(cb => cb.checked = false);
    selectedCountries = [];

    // Hide reset button
    btn.style.display = "none";

    // Re-run filter to show all
    filterCards();
  });
});


// FOCUS EVENT
allInputFields.forEach((inputField, index) => {
  inputField.addEventListener('focus', () => {
    allCloseButtons[index].style.display = 'block';
  });
});

// CLEAR BUTTON
allCloseButtons.forEach((btn, index) => {
  btn.addEventListener("click", () => {
    allInputFields[index].value = "";
    allEmptyStates[index].querySelector(".input_value").textContent = "";
    selectedCountries = [];
    searchResultsDiv.innerHTML = "";
    searchResultsDiv.style.display = "none";
    allGrids.forEach(g => g.style.display = "flex");
    allEmptyStates[index].style.display = "none";
    btn.style.display = "none";
    allFacilitatorRelated.forEach(fr => fr.style.display = "none");
    updateWrapperClass(allInputFields[index], allWrappers[index]);
  });
});

// DROPDOWN CLOSE OUTSIDE CLICK
document.addEventListener("click", (event) => {
  allDropdownMenus.forEach((menu, index) => {
    if (!menu.contains(event.target) && !allDropdowns[index].contains(event.target)) {
      allDropdowns[index].removeAttribute("open");
    }
  });
});
